(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-variant-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('productVariantDetails', () => ({
      variants: {},
      activeVariantId: null,
      activeVariant: {},

      init() {
        const jsonEl = this.$el.querySelector('[data-variant-details-json]');
        const initialVariantId = this.$el.dataset.currentVariantId;

        if (jsonEl) {
          try {
            this.variants = JSON.parse(jsonEl.textContent);
          } catch (error) {
            this.variants = {};
          }
        }

        this.setActiveVariant(initialVariantId);
        this.bindVariantChanges();
      },

      bindVariantChanges() {
        const productSection = document.querySelector('[data-section-type="product"]') || document;
        const productSelect = productSection.querySelector('[data-product-select]');

        if (productSelect) {
          productSelect.addEventListener('change', () => {
            this.setActiveVariant(productSelect.value);
          });
        }

        document.addEventListener('variant:change', (event) => {
          const variant = event.detail && event.detail.variant;

          if (!variant || !variant.id) return;

          this.setActiveVariant(variant.id);
        });

        document.addEventListener('change', () => {
          window.requestAnimationFrame(() => {
            const updatedSelect = productSection.querySelector('[data-product-select]');

            if (!updatedSelect || !updatedSelect.value) return;

            this.setActiveVariant(updatedSelect.value);
          });
        });
      },

      setActiveVariant(variantId) {
        if (!variantId || !this.variants[variantId]) return;

        this.activeVariantId = variantId;
        this.activeVariant = this.variants[variantId];
      },
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
